import React, { CSSProperties } from 'react';
import LoginBox from './LoginBox';

interface SessionRecoveryOverlayProps {
  // True while a silent re-auth is in flight (or a manual re-login redirect is starting): show a
  // spinner rather than the login button.
  loading: boolean;
  authProvider: string | null;
  onLogin: () => void;
  onCiscoSSO: () => void;
}

// A full-screen, opaque backdrop carrying the same background as the login screen. The app stays
// mounted underneath — so the route, path and in-memory context are preserved — but nothing behind
// it is visible, so an expired session can never leave sensitive data on screen for whoever is at
// the keyboard. Sits above every app layer, including the tooltip/popover z-index (99999).
const backdropStyle: CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: 100000,
  backgroundColor: '#0b1f33',
  backgroundImage: "url('/toolbox_background.png')",
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
};

const SessionRecoveryOverlay: React.FC<SessionRecoveryOverlayProps> = ({
  loading,
  authProvider,
  onLogin,
  onCiscoSSO,
}) => {
  const isCisco = authProvider === 'cisco_sso';

  return (
    <>
      <div style={backdropStyle} aria-hidden="true" />
      <LoginBox
        loading={loading}
        onClick={onLogin}
        onCiscoSSOClick={onCiscoSSO}
        // A Cisco SSO user re-authenticates with Cisco SSO; a Salesforce user with Salesforce, and
        // may still fall back to Cisco SSO via the accordion.
        buttonText={isCisco ? 'Re-authenticate with Cisco SSO' : 'Login with Salesforce'}
        loadingText="Restoring your session..."
        subtitle="Your session expired. Sign in to continue where you left off."
        showCiscoOption={!isCisco}
        overlayZIndex={100001}
      />
    </>
  );
};

export default SessionRecoveryOverlay;
